import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from 'hooks/store'
import { setTitle } from 'reducers/activecourse/activecourseSlice'
import { CourseTabTitle } from 'share/domain/course'
import CourseTabPlaceOrderAddSpouseOrJointDebtorForm from 'components/organisms/CourseTabPlaceOrderAddSpouseOrJointDebtorForm'

const CourseTabPlaceOrderAddSpouseOrJointDebtor = (): JSX.Element => {
  const dispatch = useAppDispatch()
  const activeCourse = useAppSelector((state) => state.activeCourse)
  const [courseName, setCourseName] = useState('first')

  useEffect(() => {
    let title = ''
    if (activeCourse?.activeTab) {
      title =
        activeCourse.activeTab === 'first'
          ? CourseTabTitle.TAKE_FIRST_COURSE
          : CourseTabTitle.TAKE_SECOND_COURSE
    }

    if (activeCourse?.activeTab === 'second') {
      setCourseName('second')
    }

    dispatch(setTitle(title))
  }, [activeCourse?.activeTab])

  return (
    <div>
      <h2>Optionally Add Spouse</h2>
      <h4>if you wish to take the {courseName} course with your spouse</h4>

      <CourseTabPlaceOrderAddSpouseOrJointDebtorForm />
    </div>
  )
}

export default CourseTabPlaceOrderAddSpouseOrJointDebtor
